export const DATE_FORMAT = 'YYYY-MM-DD';
export const INPUT_DATE_FORMAT = 'YYYY/MM/DD';
export const PRETTY_DATE_FORMAT = 'MMMM Do[,] YYYY';
export const PRETTY_SMALL_DATE_FORMAT = 'MMM Do';
export const TIME_FORMAT = 'HH:mm';

export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const PRETTY_DATE_TIME_FORMAT = 'MMMM Do[,] YYYY [at] HH:mm A';
